<template>
    <div class="queryNumber" v-if="showView">
        <van-nav-bar
                :fixed='true'
                title="在网号码查询"
        />

        <div class="order-search">
            <van-search
                    v-model="search.psptId"
                    placeholder="请输入身份证号码"
                    left-icon='phone-o'
                    shape="round"
                    show-action
                    @search="onSearch(true)"
                    @cancel="onCancel"
            >
                <!--<div slot="action" style="color:#25C973;" @click="onSearch(true)">查询</div>-->
                <div slot="action"  style="color:#4280c9;"><van-button round type="info" @click="onSearch(true)">查询</van-button></div>
            </van-search>
        </div>

        <div class="order-list">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    :error.sync="loadError"
                    :immediate-check=false
                    @load="onLoad"
            >
                <van-collapse class="order-list-collapse" v-for="(item,index) in orderList"  v-bind:key='index'>
                        <van-cell
                                title-class='order-list-cell-title'
                                value-class='order-list-cell-value'
                                size='large'
                                title="手机号码"
                                :value="item">
                        </van-cell>
                </van-collapse>
            </van-list>

        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
    import {isWeiXin} from '../../common/functionUtil'

    export default {
        name: 'queryNumber',
        data(){
            return{
                search:{
                    psptId:''
                },
                loading: false,
                loadError:false,
                finished: false,
                activeNames:[],
                orderList: [],
                Toast,
                page: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                    paging: "1",
                }
            }
        },
        created(){
            if(!this.isWeiXin()){
                this.$toast({
                    message: "请在微信手机端中打开该链接",
                    icon: 'fail'
                });
                this.showView = false;
                return;
            }else{
                this.showView = true;
            }
        },
        methods: {
            isWeiXin,
            onCancel() {
                Toast('取消');
            },
            onLoad() {
                // 异步更新数据
                setTimeout(() => {
                    this.onSearch(false);
                    this.page.pageNum = this.page.pageNum + 1;
                }, 500);
            },
            onSearch(reset){
                if(reset){
                    this.orderList=[];
                }
                if(this.search.psptId == '' || this.search.psptId.length != 18){
                    this.$toast({
                        message: '请输入有效证件号',
                        icon: 'fail'
                    });
                    return;
                }

                var data = {
                    ...this.page,
                    service:'user.queryNumber',
                    psptId:this.search.psptId,
                }
                this.$api.post("/mstx/pr/gateway.do", data,(res)=>{
                    this.loadError = false;
                    // 加载状态结束
                    this.loading = false;
                    if(res != null && res.list.length > 0){
                        for(var i = 0; i < res.list.length; i++){
                            this.orderList.push(res.list[i]);
                        }
                        if(res.list.length < this.page.pageSize){
                            this.finished = true;
                            this.page.pageNum = 1;
                        }
                    }else {
                        if (this.page.pageNum == 1) {
                            this.$toast.fail("暂无您的在网号码...");
                        }
                        this.page.pageNum = 1;
                        this.finished = true;
                    }
                    }, (res)=>{
                        this.$toast.fail(res.errorMsg);
                        this.page.pageNum =  this.page.pageNum - 1;
                        this.loading = false;
                        this.finished = false;
                        this.loadError = true;
                    });
            }
        }
    }
</script>

<style lang="less">
    .queryNumber {
        padding-bottom: 50px;
        &-orderOption{
            &-content{
                margin: 10px;
                display:flex;
                font-size: 14px;
                &-title{
                    float:left;
                    margin:0px 5px;
                    color: rgb(119, 118, 118);
                }
            }

        }


        &-swipe {
            margin-top: 47px;
            img {
                width: 100%;
                display: block;
                height: 200px;
            }
        }

        &-title {
            font-size: 16px;
        }

        &-price {
            color: #f44;
        }

        &-express {
            color: #999;
            font-size: 12px;
            padding: 5px 15px;
        }

        &-cell-group {
            margin: 15px 0;

            .van-cell__value {
                color: #999;
            }
        }

        &-tag {
            margin-left: 5px;
        }
    }

    .iconLabel{
        font-size: 12px;
        color: #999;
        margin: 5px 0px;
    }

</style>
